import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { AppContext } from 'src/components/app-context';
import {
  productPriceClick,
  productClickOutBounce,
} from '../../actions/product';
import { AppState } from '../../../../reducers';
import { PriceListProps, PriceListStateProps } from './types';
import { PriceListPanel } from './price-list-panel';
import { PriceListPanelWrapper } from './styles';

const PriceList: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<PriceListProps>
>> = props => {
  const { product, category, me, priceList, ...priceListPanelProps } = props;

  const { market } = useContext(AppContext);
  return (
    <PriceListPanelWrapper>
      <PriceListPanel
        me={me}
        showProductInformationTexts={market.showProductInformationTexts}
        storeStatistics={priceList?.meta?.storeStatistics}
        {...priceListPanelProps}
      />
    </PriceListPanelWrapper>
  );
};

const mapStateToProps = (state: AppState): PriceListStateProps => ({
  me: state.areas.account.me,
});

const dispatchProps = {
  dispatchProductPriceClick: productPriceClick,
  dispatchProductClickOutBounce: productClickOutBounce,
};

export default connect(mapStateToProps, dispatchProps)(PriceList);
